<template>
  <div>
    <el-select
      ref="customer"
      v-model="selected"
      filterable
      v-on:keyup.native.enter="enter"
      v-loading="loading"
      :multiple="multiple"
      clearable
      :size="size"
      placeholder="Selecione  um cliente"
      @change="update()"
      remote
      collapse-tags
      :remote-method="search"
    >
      <el-option
        v-for="row of customers"
        :key="row.id"
        :label="row.name"
        :value="row.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { CustomerService } from "@/services/customers/customers.services";
import { isArray } from "bootstrap-vue/esm/utils/inspect";
export default {
  name: "CustomerList",
  data: function () {
    return {
      customers: [],
      selected: "",
      loading: false,
    };
  },
  props: {
    current: Array,
    multiple: false,
    customerType: 0,
    pdv: false,
    size: "",
  },
  watch: {
    current(value) {
      const vm = this;
      if (!value || !value.length) {
        return;
      }
      const ids = isArray(value) ? value : [value];
      const same = isArray(vm.selected)
        ? ids.length === vm.selected.length && ids.every((id) => vm.selected.includes(id))
        : ids.length === 1 && ids[0] === vm.selected;
      if (!same) {
        vm.fetchCustomers();
      }
    },
    customerType(newValue, oldValue) {
      const vm = this;
      vm.fetchCustomers();
    },
  },
  methods: {
    focus() {
      this.$refs.customer.$el.getElementsByTagName("input")[0].focus();
    },

    clear() {
      this.selected = "";
    },
    enter() {
      this.$emit("enter");
    },
    list() {
      return thism.customers;
    },
    search(query) {
      this.fetchCustomers(query);
    },

    fetchCustomers(query) {
      const vm = this;
      vm.loading = true;
      setTimeout(() => {
        if (vm.$props.current && vm.$props.current.length && !query) {
          const ids = isArray(vm.$props.current) ? vm.$props.current : [vm.$props.current];
          Promise.all(ids.map((id) => CustomerService.get(id)))
            .then((responses) => {
              responses.forEach((response) => {
                if (!vm.customers.find((x) => x.id === response.id)) vm.customers.push(response);
              });
              vm.selected = vm.multiple ? [...ids] : ids[0];
              vm.$emit("selected", vm.selected, responses[0]);
            })
            .catch((error) => {
              this.$message({ type: "error", message: error });
            })
            .finally(() => (vm.loading = false));
        } else {
          CustomerService.select(50, 1, vm.customerType, query || "", vm.pdv)
            .then((response) => {
              vm.customers = response.records;
            })
            .catch((error) => {
              this.$message({ type: "error", message: error });
            })
            .finally(() => (vm.loading = false));
        }
      }, 500);
    },

    update() {
      const vm = this;
      const customerNameList = vm.selected
        ? vm.multiple
          ? vm.selected.map((x) => {
              const customerData = vm.customers.find((y) => y.id === x);
              return customerData ? customerData.name : "";
            })
          : vm.customers.find((y) => y.id === vm.selected).name
        : "";
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected, customerNameList);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchCustomers();
  },
};
</script>
